import { GetterTree } from 'vuex'
import { RootState } from '../../types'
import { SchedulingState } from './types'

export const getters: GetterTree<SchedulingState, RootState> = {
  test: () => {
    return 'scheduling module test getters'
  },
  getCurrentSetupState: (state: any) => {
    return Object.keys(state.setupState).find((arr) => state.setupState[arr] === 'active')
  },
  getCompanySettingData: (state: any, _: any, rootState: any, rootGetters: any) => {
    return {
      defaultLang: state.defaultLang,
      customerName: rootGetters['auth/getCustomerName'],
      timezone: rootState.timezone,
      dayPlanNg: state.dayPlanNg,
      dayPlanOk: state.dayPlanOk,
      timePlanNg: state.timePlanNg,
      timePlanOk: state.timePlanOk,
      sharingAdjustmentNg: state.sharingAdjustmentNg,
      sharingAdjustmentOk: state.sharingAdjustmentOk,
      workHourSetting: state.workHourSetting,
    }
  },
  getUserSettingData: (state: any, _: any, rootState: any) => {
    return {
      userLang: rootState.lang,
      availableLocations: state.availableLocations,
      selectedLocation: state.selectedLocation,
      dayPlanNg: state.userDayPlanNg,
      dayPlanOk: state.userDayPlanOk,
      timePlanNg: state.userTimePlanNg,
      timePlanOk: state.userTimePlanOk,
      sharingAdjustmentNg: state.userSharingAdjustmentNg,
      sharingAdjustmentOk: state.userSharingAdjustmentOk,
    }
  }
}

export default getters
